import React from 'react';
import LeftBar from '../Components/LeftBar';
import Dashnav from '../Components/Dashnav';
import SettingsComp from './SettingsComp';
import './dash.css';

function Settings() {
  return (
    <div className='mainContainer'>
      <LeftBar />
      <div className='theMainContainer'>
        <Dashnav />
        <SettingsComp />
      </div>
    </div>
  );
}

export default Settings;
